{
  "areaCameraListPopover": {
    "title": "{{areaName}}のカメラ一覧",
    "message": "カメラがありません"
  },
  "areaCreateDialog": {
    "required": "エリア名を入力してください",
    "max": "エリア名は100文字以下で入力してください",
    "test": "電話番号は数字とハイフンのみ入力可能です",
    "test2": "郵便番号は7桁の数字で入力してください",
    "enqueueSnackbar": "エリアを作成しました",
    "enqueueSnackbar2": "エリアの作成に失敗しました",
    "text": "作成中...",
    "text2": "作成",
    "title": "エリア作成",
    "label": "エリア名",
    "label2": "電話番号",
    "label3": "郵便番号",
    "label4": "都道府県",
    "label5": "市区町村",
    "label6": "番地・建物名"
  },
  "areaDeleteDialog": {
    "enqueueSnackbar": "エリアを削除しました",
    "enqueueSnackbar2": "エリアの削除に失敗しました",
    "text": "削除中...",
    "title": "エリアを削除",
    "text2": "」を削除しますか？",
    "text3": "この操作は元に戻せません。"
  },
  "areaEditDialog": {
    "required": "エリア名を入力してください",
    "max": "エリア名は100文字以下で入力してください",
    "matches": "電話番号は数字とハイフンのみ入力可能です",
    "matches2": "郵便番号は7桁の数字で入力してください",
    "test": "クリップ保存容量は0以上の数値で入力してください",
    "enqueueSnackbar": "エリアを更新しました",
    "enqueueSnackbar2": "エリアの更新に失敗しました",
    "text": "読み込み中...",
    "text2": "エリア情報が見つかりません",
    "title": "エリア編集",
    "text3": "更新中...",
    "label": "エリア名",
    "label2": "電話番号",
    "label3": "郵便番号",
    "label4": "都道府県",
    "label5": "市区町村",
    "label6": "番地・建物名",
    "label7": "クリップ保存容量（GB）"
  },
  "areaFilterBar": {
    "placeholder": "エリア名で検索",
    "button": "エリア作成"
  },
  "areaTable": {
    "label": "エリア名",
    "text": "カメラ数",
    "text2": "{{cameraCount}}台",
    "text3": "ユーザー数",
    "text4": "{{userCount}}名",
    "text5": "マップ"
  },
  "areaTableHeader": {
    "text": "件"
  },
  "areaUserListPopover": {
    "title": "{{areaName}}のユーザー一覧",
    "message": "ユーザーがいません"
  },
  "area": {
    "title": "エリア管理"
  }
}
